export default __webpack_public_path__ + "static/media/sidebar-14.57736de1.png";